<template>
	<div class="p-x-20 p-y-16 bg-white">
		<div class="f-bold f-18 f-c-black">{{ info.data.nama_konsumen }}</div>
		<div class="f-regular f-14">
			<span class="f-c-midgrey">Total Transaksi </span>
			<span class="f-c-black">
				{{ (info.data.total_transaksi === undefined) ?
				info.data.total_transaksi_selfservice + info.data.total_transaksi_dropoff
				: info.data.total_transaksi | currency
				}}
			</span>
		</div>
		<div class="f-regular f-14 f-c-midgrey" v-if="info.data.total_nota > 0">
			Terakhir {{ info.data.transaksi_terakhir }}
		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardTransaksiInfoCustomer",
	props: {
		info: Object,
	}
}
</script>